import { type CallbackInterface } from 'recoil'

import { modalActivateSimulateState } from 'Pages/Workflow/recoil/state/modalActivateSimulate'

export const modalActivateSimulateCloseCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalActivateSimulateState)
  }

export const modalActivateSimulateSimulateCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(modalActivateSimulateState, {
      show: true,
      mode: 'simulate'
    })
  }
